import { render, staticRenderFns } from "./OceanoDefaultSection.vue?vue&type=template&id=c847a096&scoped=true"
import script from "./OceanoDefaultSection.vue?vue&type=script&lang=ts"
export * from "./OceanoDefaultSection.vue?vue&type=script&lang=ts"
import style0 from "./OceanoDefaultSection.vue?vue&type=style&index=0&id=c847a096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c847a096",
  null
  
)

export default component.exports